import { IneligibleUpgradeProducts } from './interfaces';
export var INTL_COUNTRIES = ['AU', 'TR', 'MX', 'CN'];
export var REVIEW_STEP_COUNTRIES = ['CA'];
export var PRICE_PLUS_TAX_COUNTRIES = ['AU'];
export var SECONDARY_CTA_COUNTRIES = ['ID'];
export var DISCONTINUED_PRODUCTS = ['CHGMnthCSNFTSG', 'CHGMnthCSNFTUK'];
export var SALE_EXPERIMENTS = ['BASE_FALL_SEMESTER_SALE', 'BASE_INTL_FALL_SEMESTER_SALE', 'CANADA_Q423', 'BASE_FALL_SEMESTER_SALE_Q12024'];
export var INELIGIBLE_UPGRADE_PRODUCTS = [IneligibleUpgradeProducts.MATH, IneligibleUpgradeProducts.EASYBIB];
export var GENERIC_ERROR_MESSAGE = 'Ugh! Something went sideways. Please try again.';

// temporary messaging while users are being migrated over from chegg to recurly
export var ORDERLINE_LOCKED = 'ORDERLINE_LOCKED';
export var MIGRATION_IN_PROGRESS_MESSAGE = 'Sorry we were not able to process your request while we are undergoing system updates. Please try again in 48 hours or follow up with Customer Support for assistance. We apologize for the inconvenience.';
export var MIGRATION_CTA_TEXT = 'Contact Support';
export var paymentHeading = /*#__PURE__*/function (paymentHeading) {
  paymentHeading["ADD_PAYMENT_METHOD_HEADING"] = "AddPaymentMethodHeading";
  paymentHeading["EDIT_PAYMENT_METHOD_HEADING"] = "EditPaymentMethodHeading";
  paymentHeading["CANCEL_ANYTIME"] = "CancelAnytime";
  return paymentHeading;
}({});
export var US_COUNTRY_CODE = 'US';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/appConstants.js
// module id = 302
// module chunks = 11